export enum PageSubType {
  Digital = 'sign_digital_documents',
  Physical = 'send_physical_document',
  Upload = 'upload_documents',
}
